export interface IPublish<T> {
  type: 'single' | 'multi';
  data: T;
}

export interface IReviewsMetricsResponse {
  collection: IReviewsMetrics[];
  collection_past30: IReviewsMetrics[];
  collection_prior30: IReviewsMetrics[];
  collection_prior7: IReviewsMetrics[];
  dateEnd: string;
  status: string;
}

export interface IReviewsMetrics {
  account: string;
  account_id: number | string;
  avgStarRating: number;
  dateEnd: string;
  dateStart: string;
  highStarsCount: number;
  lowStarsCount: number;
  medStarsCount: number;
  totalRepliedTo: number;
  totalReviews: number;
  avgRatingsDaily?: { date: any, value: number }[];
  totalReviewsDaily?: { date: any, value: number }[];
}

export interface IReviewDataResponse {
  collection: IReviewData[];
  totalEntries: number;
}

export interface IReviewData {
  loginId?: string;
  account: string;
  account_id: number;
  attrs: any | null;
  businessName: string;
  addressLines: string[];
  city: string;
  state: string;
  postalCode: string;
  date_id: number;
  location_id: number;
  replyComment: string | null;
  replyUpdatedAt: any | null;
  reviewCreatedAt: any;
  reviewId: string;
  reviewIdent: string;
  reviewUpdatedAt: any;
  reviewerComment: string | null;
  reviewerIsAnonymous: string | null;
  reviewerName: string;
  reviewerProfileUrl: string;
  starRating: number;
  storeCode: string;
  _id: number;
  reviewTooltip?: string;
  replyTooltip?: string;
  directory?: string;
  vendorIdent?: string;
  icon?: string;
  tags?: string[];
}

export enum PeriodType {
  DAY = 'Day',
  WEEK = 'Week',
  MONTH = 'Month',
  QUARTER = 'Quarter',
  YEAR = 'Year',
  ALL_TIME = 'AllTime',
  CUSTOM_DATE = 'Period',
}

export enum PeriodText {
  THIS_MONTH = 'This month',
  LAST_30_DAYS = 'Last 30 days',
  LAST_MONTH = 'Last month',
  YEAR_TO_DATE = 'Year to date',
  LAST_12_MONTHS = 'Last 12 months',
  ALL_TIME = 'All time',
}

export interface IReviewMulti extends IReviewData {
  pos?: number;
}

export interface ICols {
  field: string;
  header: string;
}

export interface IFitersObject {
  [key: string]: string[];
}

export interface IExportJob {
  job_id: string;
  status: string;
  created_at: string;
  updated_at: string;
  row_count: number | null;
  download_url?: string;
  download_url_expires_seconds?: number;
}

export interface IExportJobsResponse {
  jobs: IExportJob[];
}
